import React from 'react';
import { useSearchkit, useSearchkitVariables } from '@searchkit/client';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import Select from '../../../Form/Select';
import FormikWrapper from '../../../Form/FormikWrapper';
var useInitialValues = function useInitialValues() {
  var parsed = useSearchkitVariables();
  var filters = {};
  if (parsed.filters) {
    parsed.filters.forEach(function (filter) {
      filters[filter.identifier] = filter.value;
    });
  }
  return filters;
};
export var SelectFacet = function SelectFacet(_ref) {
  var facet = _ref.facet;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var api = useSearchkit();
  var options = facet.entries.map(function (entry) {
    return {
      value: entry.label,
      label: facet.identifier === 'type' ? t("tags.".concat(entry.label.toLowerCase())) : entry.label,
      disabled: parseInt(entry.count) === 0
    };
  });
  var placeHolder = t("placeholders.".concat(facet.identifier, ".placeholder"));
  var classes = classNames('Facet', 'SelectFacet', "Facet--".concat(facet.identifier));
  var initialValues = useInitialValues();
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    key: facet.identifier
  }, /*#__PURE__*/React.createElement(FormikWrapper, {
    initialValues: initialValues
  }, /*#__PURE__*/React.createElement(Select, {
    title: facet.label,
    required: true,
    placeholder: placeHolder,
    fieldName: facet.identifier,
    options: options,
    isSearchable: facet.isSearchable,
    isClearable: facet.isClearable,
    onChange: function onChange(value) {
      api.removeFiltersByIdentifier(facet.identifier);
      api.setPage({
        from: 0
      });
      if (value) {
        api.addFilter({
          identifier: facet.identifier,
          value: value
        });
      }
      api.search();
    }
  })));
};
SelectFacet.DISPLAY = 'SelectFacet';
export default SelectFacet;